import { DynamicStandaloneIcon } from '@/components/Icon';
import { propClassName } from '@/styles/Loader';
import { ClassNameProp, ComponentPropsWithRef, ComponentWithRef } from '@/types/component';
import { withNonHTMLChildren, withSafeInnerHTML } from 'lib/utils';
import cn from 'lib/utils/cn';
import { forwardRef } from 'react';

export interface LoaderComponentProps extends ComponentPropsWithRef<'div'> {
  animation?: ClassNameProp<'default' | 'alternative'>;
  colors?: ClassNameProp;
  size?: ClassNameProp;
  variant?: ClassNameProp;
}

const LoaderComponent: ComponentWithRef<HTMLDivElement, LoaderComponentProps> = forwardRef(function LoaderComponent(
  { animation, children, className, colors, size, variant, ...props },
  ref
) {
  const animationClassName = propClassName('animation', animation);
  const colorClassName = propClassName('colors', colors);
  const sizeClassName = propClassName('size', size);
  const variantClassName = propClassName('variant', variant);

  const componentClassName = cn(animationClassName, colorClassName, sizeClassName, variantClassName, className);

  const innerHtml = withSafeInnerHTML(children);
  const nonHtmlChildren = withNonHTMLChildren(children);
  const hasContent = Boolean(innerHtml.dangerouslySetInnerHTML || nonHtmlChildren);

  return (
    <div className={componentClassName} {...withSafeInnerHTML(children)} {...props} ref={ref}>
      {withNonHTMLChildren(children)}
      {!hasContent && <DynamicStandaloneIcon name="add" options={{ size: 'extraLarge' }} />}
    </div>
  );
});

export const Loader = LoaderComponent;
